import s from './office/state'
import * as a from './office/actions'
import * as m from './office/mutations'
import * as g from './office/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
